let cachedDeviceName: string | null = null;
let cachedDeviceLocation: string | null = null;

export function getDeviceName(): string {
  if (cachedDeviceName) return cachedDeviceName;

  try {
    const ua = navigator.userAgent;
    const platform = navigator.platform || 'Unknown';

    let browser = 'Unknown';
    if (ua.includes('Edg/')) {
      const match = ua.match(/Edg\/([\d.]+)/);
      browser = match ? `Edge/${match[1]}` : 'Edge';
    } else if (ua.includes('Chrome/')) {
      const match = ua.match(/Chrome\/([\d.]+)/);
      browser = match ? `Chrome/${match[1]}` : 'Chrome';
    } else if (ua.includes('Firefox/')) {
      const match = ua.match(/Firefox\/([\d.]+)/);
      browser = match ? `Firefox/${match[1]}` : 'Firefox';
    } else if (ua.includes('Safari/') && !ua.includes('Chrome')) {
      const match = ua.match(/Version\/([\d.]+)/);
      browser = match ? `Safari/${match[1]}` : 'Safari';
    }

    cachedDeviceName = `${platform} - ${browser}`;
  } catch {
    cachedDeviceName = 'Unknown';
  }

  return cachedDeviceName;
}

export function getDeviceLocation(): string {
  if (cachedDeviceLocation) return cachedDeviceLocation;

  try {
    cachedDeviceLocation = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Unknown';
  } catch {
    cachedDeviceLocation = 'Unknown';
  }

  return cachedDeviceLocation;
}

export function getDeviceInfo(): { DeviceName: string; DeviceLocation: string } {
  return {
    DeviceName: getDeviceName(),
    DeviceLocation: getDeviceLocation(),
  };
}
